import React, { useState } from 'react'
import { injectIntl } from 'react-intl'
import { Image } from 'cloudinary-react'
import { useStyles } from './TechlinkMobileAppBar_style'
import { AppBar, Hidden, IconButton, Box } from '@material-ui/core'
import IconFactory from 'icons/IconFactory/IconFactory'
import TechlinkMobileBurgerMenu from '../TechlinkMobileBurgerMenu/TechlinkMobileBurgerMenu'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'

const TechlinkMobileAppBar = (props) => {
    const { intl, altLangUrls, user, paramsForUrlTranslation, darkMode } = props
    const classes = useStyles()
    const { formatMessage } = intl
    const [open, setOpen] = useState(false)

    const openModal = () => {
        setOpen(true)
    }

    const closeModal = () => {
        setOpen(false)
    }

    return (
        <Hidden mdUp>
            <TechlinkMobileBurgerMenu
                open={open}
                closeModal={closeModal}
                user={user}
                altLangUrls={altLangUrls}
                paramsForUrlTranslation={paramsForUrlTranslation}
            />
            <AppBar position='static' color='white' elevation={0} className={classes.appBar}>
                <RouteMapLink page={`techlink/${formatMessage({ id: 'routes.companies' })}`}>
                    <Image
                        cloudName='studentbe'
                        publicId='techlink/install-tomorrow-black'
                        alt='Student.be logo'
                    />
                </RouteMapLink>
                <Box className={classes.iconsContainer}>
                    <IconButton
                        onClick={openModal}
                        className={classes.button}
                        disableRipple
                    >
                        <IconFactory icon='bars' className={classes.burgerIcon} />
                    </IconButton>
                </Box>
            </AppBar>
        </Hidden>
    )
}

export default injectIntl(TechlinkMobileAppBar)
